/**
 * File Hash Utilities
 *
 * Provides SHA256 hash computation for file deduplication
 */

/**
 * Compute SHA256 hash of a file
 *
 * @param {File} file - The file to hash
 * @returns {Promise<string>} - Hex string of SHA256 hash
 */
export const computeFileSHA256 = async (file) => {
    try {
        const arrayBuffer = await file.arrayBuffer();
        const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    } catch (error) {
        console.error('Error computing file hash:', error);
        throw new Error('Failed to compute file hash');
    }
};

/**
 * Format file size for display
 *
 * @param {number} bytes - File size in bytes
 * @returns {string} - Formatted size string
 */
export const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};
